import { Modal, Button } from "antd";
import { useState } from "react";
import ReactDOM from "react-dom";
import { t } from "i18next";

const TokenDurationModal = ({ defaultType = 1 }) => {
    return new Promise((resolve) => {
        const container = document.createElement("div");
        document.body.appendChild(container);

        const ModalWrapper = () => {
            const [tokenType, setTokenType] = useState(defaultType);

            const close = () => {
                ReactDOM.unmountComponentAtNode(container);
                document.body.removeChild(container);
            };

            return (
                <Modal
                    open={true} // AntD v4+ için visible yerine open
                    title={t('Select the sharing duration')}
                    onCancel={() => { close(); resolve(null); }}
                    footer={[
                        <Button key="cancel" onClick={() => { close(); resolve(null); }}>{t('Cancel')}</Button>,
                        <Button key="ok" type="primary" onClick={() => { close(); resolve(tokenType); }}>{t('Share')}</Button>
                    ]}
                    centered
                    bodyStyle={{ padding: "20px", textAlign: "center" }}
                >
                    <select
                        value={tokenType}
                        onChange={(e) => setTokenType(parseInt(e.target.value))}
                        style={{
                            width: "100%",
                            padding: "10px",
                            fontSize: "16px",
                            borderRadius: "6px",
                            border: "1px solid #d9d9d9",
                            outline: "none",
                            marginTop: "10px"
                        }}
                    >
                        <option value={1}>12 Saat</option>
                        <option value={2}>24 Saat</option>
                        <option value={3}>72 Saat</option>
                    </select>
                </Modal>
            );
        };

        ReactDOM.render(<ModalWrapper />, container);
    });
};

export default TokenDurationModal;